import { escapeHtml } from 'shared-helpers/common';
import { useReduxState } from 'hooks';
import { newlinesToLineBreak } from 'lib/helpers';
import { Icon } from 'components/common/icons';
import { TaskPointsBadge } from '.';

const OpenQuestionAnswer = ({ filename, filepath, maxScore, score, text }) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="answer">
      <div className="content">
        {text ? (
          <div
            aria-label={messages.commonText}
            className="text"
            dangerouslySetInnerHTML={{
              __html: newlinesToLineBreak(escapeHtml(text))
            }}
          />
        ) : null}

        {filename && filepath ? (
          <a
            aria-label={messages.commonFile}
            className="file"
            href={filepath}
            rel="noopener noreferrer"
            target="_blank"
          >
            <div className="file-icon">
              <Icon icon={['far', 'file']} fixedWidth={true} />
            </div>
            <div className="file-name">{filename}</div>
          </a>
        ) : null}
      </div>

      <TaskPointsBadge
        hideSuccessBadge={true}
        maxPoints={maxScore}
        points={score}
      />

      <style jsx>{`
        .answer {
          color: ${theme.textColor};
          font-size: 1.5rem;
        }
        .content {
          background-color: white;
          border-radius: ${theme.cardBorderRadius};
          padding: 15px;
        }
        .text {
          color: ${theme.textColorLight};
        }
        .file {
          background-color: ${theme.lightGrey};
          border-radius: 4px;
          color: inherit;
          cursor: pointer;
          display: inline-block;
          margin-top: 15px;
          padding: 3px 8px;
          text-decoration: none;
        }
        .file:focus,
        .file:hover {
          text-decoration: underline;
        }
        .file-icon {
          display: inline-block;
          font-size: 0.9em;
          margin-right: 5px;
        }
        .file-name {
          display: inline-block;
          font-size: 0.9em;
          font-weight: 600;
          text-decoration: inherit;
          position: relative;
          top: -1px;
        }
      `}</style>
    </div>
  );
};

export default OpenQuestionAnswer;
